export class Theme {
  logo!: string;
  product!: string;
  favicon!: string;
  styles!: {
    background: string;
    actionColor: string;
    buttons: {
      primary: string,
      primaryHover: string,
      primaryText: string,
      secondary: string,
      secondaryHover: string,
      secondaryText: string,
    }
  };

  static default(): Theme {
    return {
      logo: '/assets/images/roadrunner/logo.png',
      product: 'Road Runner',
      favicon: 'assets/images/roadrunner/favicon.ico',
      styles: {
        background: 'url(../../../../../assets/images/background.jpg) 0% 0% / 100% 100% fixed',
        actionColor: '#5b53ff',
        buttons: {
          primary: '#002be7',
          primaryHover: '#0026ce',
          primaryText: '#fcfcfc',
          secondary: '#eee',
          secondaryHover: '#e1e1e1',
          secondaryText: '#404040'
        }
      }
    }
  }

  static cinedeck(): Theme {
    return {
      logo: '/assets/images/cinedeck/logo.png',
      product: 'Cinedeck',
      favicon: 'assets/images/cinedeck/favicon.ico',
      styles: {
        background: 'linear-gradient(to bottom, #0f2027, #12252c, #152931, #192e37, #1c333c, #1e3741, #213c46, #23404b, #254551, #274957, #2a4e5e, #2c5364)',
        actionColor: '#2FA4C7', // '#5F9BFF',
        buttons: {
          primary: '#2FA4C7',
          primaryHover: '#278DAA',
          primaryText: '#ffffff',
          secondary: '#eee',
          secondaryHover: '#e1e1e1',
          secondaryText: '#404040'
        }
      }
    }
  }

}